import { render, staticRenderFns } from "./Gradients.vue?vue&type=template&id=9ee42d8a&scoped=true"
import script from "./Gradients.vue?vue&type=script&lang=js"
export * from "./Gradients.vue?vue&type=script&lang=js"
import style0 from "./Gradients.vue?vue&type=style&index=0&id=9ee42d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee42d8a",
  null
  
)

export default component.exports